/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Civil_Brief_Moose_BeamInputs */

const fr_civil_brief_moose_beam = /** @type {(inputs: Civil_Brief_Moose_BeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

/**

* @param {Civil_Brief_Moose_BeamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const civil_brief_moose_beam = /** @type {((inputs?: Civil_Brief_Moose_BeamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Civil_Brief_Moose_BeamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_civil_brief_moose_beam(inputs)
});